import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  ru: {
    main: {
      january: "Січень",
      february: "Лютий",
      march: "Березень",
      april: "Квітень",
      may: "Травень",
      june: "Червень",
      july: "Липень",
      august: "Серпень",
      september: "Вересень",
      october: "Жовтень",
      november: "Листопад",
      december: "Грудень",
      mo: 'пн',
      tw: 'вт',
      we: 'ср',
      thu: 'чт',
      fr: 'пт',
      st: 'сб',
      sd: 'нд',
      begin: "Начать",
      quests: "Квести",
      tournaments: "Турніри",
      main: "Головна",
      shop: "Магазин",
      enter: "Увійти",
      to_enter: "Войти",
      register: "Регистрация",
      to_register: "Зарегистрироваться",
      take: "Придбати",
      begin_quest: "Начать квест",
      license:
        "Лицензия на осуществление деятельности букмекерской конторы №20019733 от 31.12.2020г. (действительна до 17.07.2028г.) выдана РГУ «Комитет индустрии туризма Министерства культуры и спорта Республики Казахстан»",
      footer_offer: "Правила и Условия Акции",
      pm_pass: "Johnny24",
      trade_link: "Trade Link",
      back: "Назад",
      link: "Посилання",
      skip: "Пропустить",
      steam_login: "Steam Login",
      settings: "Налаштування",
      community: "Сообщество",
      public_match_history: "Общедоступная история матчей",
      help: "Підтримка",
      password: "Пароль",
      phone: "Номер телефона",
      enter_help: "Помощь при входе",
      clear: "Зрозуміло",
      next: "Дальше",
      attach: "Прикріпити",
      product_filter: "Сортировка",
      game_dota: "Dota 2",
      game_cs: "CS 2",
      reset_filters: "Скинути всі",
      quest_filter: "Фильтр квестов",
      nothing_here: "Тут поки нічого немає",
      try_another_filters: "Спробуйте інші налаштування фільтра</a>",
      more: "Більше",
      make_bets: "Делайте ставки в Johnny24",
      go: "Перейти",
      loading: "Загрузка Страницы...",
      reward_received: "Залутанi",
      ended: "Завершенi",
      active: "Активнi",
      new: "Новi",
      end: "Завершений",
      soon: "Доступно",
      activated: "Активен",
      account: "Номер счета",
      cancel: "Скасувати",
      quit: "Вийти",
      quit_from_profile: "Вийти з Профілю",
      confirm_quite: "Дійсно хочеш вийти без призів?",
      main_info: "Основна Інформація",
      profile_settings: "Налаштування профілю",
      attach_trade_link: "Додай трейд посилання для отримання предметів",
      attach_steam: "Прив’яжи свій Steam акаунт.",
      reg_first: "Выполняя регистрацию или вход, вы соглашаетесь с",
      reg_second: "Правилами и Условиями Aкции",
    },
    promo: {
      title1: "Зарабатывайте баллы",
      title1_hg: "с Johnny24",
      title2: "Выполняйте квесты",
      patch1: "Пройдите верификацию",
      patch2: "Пополните счет",
      patch3: "Соберите экспресс",
      quests: "Квесты",
    },
    promogroup: {
      title: "Обменивайте баллы",
      title_hg: "на призы",
      pic1_name: "Freebet на 5000 тг",
      pic2_name: "CS 2",
      pic3_name: "Dota 2",
      pic4_name: "Лутбокс",
      pic_prize: "846 000 XP",
      desc_title: "больше призов",
      desc_title_hg: "внутри",
      shop: "Магазин",
    },
    prefooter: {
      title: "Стартовый",
      title_hg: "буст",
      desc1: "Получите",
      desc1_hg: "300 XP",
      desc1_end: "на старте!",
      desc2: "Обменивайте",
      desc2_hg: "стартовый буст",
      na: "на",
      desc1_end_hg: "лутбокс",
    },
    banner: {
      title: "Фармите с Johnny24",
      subtitle:
        "Выполняйте квесты, получайте XP и обменивайте на крутые призы",
      btn: "Фармить призы",
      title1: "ЛУТАЙ ПРИЗИ З JOHNNY24",
      title1_hg: "квесты",
      title2: "Зарабатывайте",
      title2_hg: "баллы",
      title3_hg: "Freebet",
      title3: "Обменивайте на",
      title3_suffix: "и скины",
      button: "Начать",
    },
    rules: {
      title: "Как это работает",
      connect: "Подключите аккаунты",
      register: "Підключи Johnny24 до Steam",
      quests: "Выполняйте квесты",
      finish: "Додай трейд посилання зі Steam у профіль ХPass",
      chest: "Открывайте сундуки",
      bonuses: "Відкрий інвентар у Steam, щоб отримувати предмети",
      store: "Магазин призов",
      change: "Виконуй щоденні квести на Johnny24",
      schatz: "Отримуй ХP бали та обмінюй їх на круті призи",
    },
    prizes: {
      title: "Призы на любой вкус",
      text1:
        "Johnny24 - это ваш источник бесконечных призов. Получайте награды и XP за каждый выполненный квест на сайте Johnny24.",
      text2:
        "Покупайте на XP все, что приглянется в магазине Xpass24: скины для CS2, Dota 2, фрибеты, мерч и многое другое. Выбор за вами!",
    },
    quests: {
      text1:
        "Выполняйте квесты, делая ставки на спорт или играя в Dota 2 через Steam. Чтобы посмотреть весь список заданий зайдите на сайт Johnny24.",
      text2: "Квесты обновляются каждый день — фармите призы бесконечно!",
    },
    faq: {
      question1: "Як зв'язати акаунти Johnny24 і Steam?",
      answer1_text1:
        "Натисни на кнопку «Лутати призи» і введи у форму свій Johnny24 ID/телефон/електронну пошту та пароль, який ти використовував під час реєстрації. Скопіювати свій ID можна з розділу «Мій акаунт» .",
      answer1_text2:
        '',
      answer1_text3:
        'Если вы не зарегистрированы, перейдите по этой ссылке <a class="yellow" href="https://parimatch.kz/ru/regtel/3" target="_blank">https://parimatch.kz/ru/regtel/3</a> и создайте учетную запись в Parimatch.',
      answer1_text4:
        "Далее вам необходимо на этой странице нажать на кнопку “Участвовать”. Введите в форму ваш ID Parimatch и пароль, с которым вы зарегистрировались.",
      answer1_text5:
        'Скопировать свой ID можно в разделе “Мой аккаунт” - <a class="yellow" href="https://parimatch.kz/ru/my-account/" target="_blank">https://parimatch.kz/ru/my-account</a>',
      question2: "Чи можу я взяти участь без облікового запису Steam?",
      answer2:
        'Так, для виконання квестів достатньо мати обліковий запис Johnny24, якщо ти не плануєш обмінювати ХP на ігрові подарунки (скіни, предмети тощо). Переходь у розділ   <a class="yellow" href="https://https://7johnny24.com/uk/gamification/profile/" target="_blank">Ліга Бонусів</a> і починай гру просто зараз.',
      question3: "Як дізнатися прогрес квестів, які я виконую?",
      answer3_text1:
        'Статус виконання можна побачити на <a class="yellow" href="https://7johnny24.com/uk/gamification/" target="_blank">сторінці квестів</a>. Зазвичай прогрес завдань оновлюється протягом 10-20 хвилин.',
      // answer3_text2:
      //   "Переходите в раздел геймификации PM Hero и начинайте играть прямо сейчас.",
      question4: "Скільки я маю часу на виконання квестів і отримання призів?",
      answer4_text1:
        "Квести оновлюються кожні 3-4 дні та мають відведений час на виконання (дивись деталі в умовах квесту). Це постійна акція, тож ти можеш накопичувати бали на балансі, щоб обміняти на бажану винагороду у магазині. ",
      // answer4_text2: "Быть зарегистрированным в Parimatch;",
      // answer4_text3: "Авторизуйтесь;",
      // answer4_text4:
      //   "Выполняйте квесты каждый день и получайте гарантированные PM баллы;",
      // answer4_text5: "Обменивайте PM баллы на предметы в магазине PM Pass;",
      question5: "Як отримати бали і призи?",
      answer5:
        "За виконання кожного квесту нараховуються певна кількість ХP балів. Для їх зарахування на твій баланс необхідно натиснути «Забрати нагороду» на сторінці квесту. Бали на балансі можна використати для обміну на призи в магазині. Всі Призи з магазину можна забрати 1 раз на 24 години. Кількість призів обмежена.",
      answer6_text1:
        "Щоб отримати ігрові предмети і скіни, які ти придбав за ХP бали, твій інвентар має бути відкритий для видимості.",
      answer6_text2: "Для цього потрібно:",
      answer6_text3: "Відкрити Steam клієнт;",
      answer6_text4:
        "Навести курсор на свій логін у правому верхньому кутку та натиснути у випадаючому меню «Інвентар»;",
      answer6_text5:
        "Натиснути на вкладку «Ще» і вибрати «Налаштування приватності»;",
      answer6_text6:
        "Поставити галочки навпроти «Відкритий» у рубриках «Статус профілю» та «Інвентар»;",
      answer6_text7: "Натиснути «Зберегти зміни».",
      answer7:
        "Якщо не знайшов відповіді на свої питання вище, пиши у онлайн чат на сайті ",
    },
    profile: {
      title: "Мій профіль",
      info: "Информация об Аккаунте",
      received_points: "Получено очков",
      current_balance: "Балів на балансі",
      dota_history_closed: "История матчей закрыта, проверьте настройки",
      go_to_settings: "Щойно функція стане доступною - ми обовʼязково повідомимо",
      in_chapter:
        "",
        match_history: "Історія Матчів",
        match_history_closed: "Тимчасово інтеграція ігор недоступна",
        go_to_dota2: "Зайдіть у Dota 2 і перейдіть у розділ Налаштування.",
        go_to_community:
          "У розділі Спільнота ви побачите Загальнодоступна історія матчів, натисніть на нього, і історія буде відкрита.",
      history_open: "Ваша історія матчів відкрита.",
      steam_attached: "Посилання на обмін зі Steam додано",
      steam_is_not_attached: "Прив’яжи свій Steam акаунт",
    },
    welcome: {
      intro_title: "- ваш пропуск в мир крутых призов",
      intro_text1: "Это официальный продукт компании Париматч.", //перевести
      intro_text2:
        "Выполняйте задания и зарабатывайте бонусные баллы, обменивайте их на freebet, скины CS2 и Dota2, лутбоксы и другие предметы в магазине.",
      shop_and_quests_shop: "Квесты и ",
      shop_and_quests_quests: "Магазины",
      shop_and_quests_text1:
        "Все очень просто. Следите за доступными вам заданиями на странице Квесты.",
      shop_and_quests_text2:
        "На каждом задании указано, сколько XP вы получите. После выполнения, ваши баллы будут начислены в профиль xpass24.",
      shop_and_quests_text3: "Вы сможете обменять их на странице Магазин.",
      quest_guide: "Поздравляем, вы в шаге от",
      quest_guide_hg: "крутых призов",
      obj_one_title: "Зарабатывайте баллы с Xpass24",
      obj_one_desc:
        "XP можно получить выполняя квесты и собирая стикербуки.",
      obj_two_title: "Ваш первый квест",
      obj_two_desc:
        "Пройди верификацию и получите фрибет на 2000 тенге и 300 XP.",
      trade_link_text1:
        "Прикрепите свою ссылку на обмен из Steam, чтобы получать скины и игровые предметы в магазине Xpass24",
      trade_link_text2: "Як отримати посилання?",
      steam_text:
        "Чтобы выполнять квесты в Dota 2, вам нужно прикрепить учетную запись Steam",
      skip_step: "Вы можете пропустить этот шаг и прикрепить ссылку позже",
    },
    reg: {
      more_than_21: "Мне больше 21 года",
      accept_offer: "Я соглашаюсь с договором оферты",
      activate_bonus: "Активировать бонус на первый депозит",
      bonus_offer: "Условия бонусного предложения",
      have_account: "Есть аккаунт?",
      no_account: "Нет аккаунта?",
    },
    help: {
      have_trouble: "Похоже, что у вас возникли проблемы со входом.",
      ask_help: "Попробуйте обратиться в службу поддержки.",
      find_trade_link:
        "Чтобы найти свой трейд URL в Steam, выполните следующие действия:",
      find_nickname: "Наведите на свой никнейм, чтоб выпало меню профиля;",
      go_to: "Перейдите в Инвентарь",
      click_button: "Кликните кнопку: “Предложения обмена”",
      open: 'Откройте: "Кто может отправлять мне предложения обмена?"',
      trade_text1: 'В графе "Сторонние сайты" есть поле "Ссылка на обмен"',
      down_here: "Тут внизу и находится трейд ссылка Steam.",
    },
    errors: {
      min_6_symbols: "Минимум 6 символов",
      min_1_number: "Минимум 1 цифра (0-9)",
      number_registered: "Номер телефона уже зарегистрирован",
      not_supported: "Номер телефона не поддерживается",
      error_data: "Ошибка в обработке данных",
      no_account:
        "Схоже дані введено некоректно або ви ще не маєте акаунту",
    },
    notifications: {
      steam_attached: "Steam акаунт прикріплений",
      dota_history_opened: "История матчей открыта",
      trade_link_attached: "Ссылка на обмен прикреплена",
      trade_link_edited: "Ссылка на обмен изменена",
      steam_edited: "Steam аккаунт изменен",
      present_send: "Подарунок вже у Steam. Поспішай забрати!",
      present_send_bonus: "Бонус вже на Jhonny24. Поспішай активувати!",
      present_send_merch: "Вітаємо! Ти успішно придбав товар.",
      not_enough_cash: "У вас недостатньо XP для обміну",
      add_trade_link: "Добавьте в Профиль ссылку на обмен в Steam ",
      technical_issues: "Идут технические работы. Обмен недоступен.",
      account_copied: "Account ID скопійовано",
      steam_copied: "Steam ID скопійовано",
      wrong_trade_link: "Неверный формат ссылки на обмен",
    },
    offer: {
      akciya: "1. Акція",
      organizator: "2. Організатор",
      member: "3. Учасник",
      login_offer: "4. Логін",
      mobile_app: "5. Термін проведення ",
      prize_offer: "6. Приз",
      offer_header: "Правила та умови акції X-Pass: ",
      quest_offer: "7. Квест",
      rules_offer: "8. Правила",
      deadline_offer: "10. Термін проведення Акції",
      location_offer: "9. Місце проведення Акції",
      territoy_offer: "11. Територія проведення Акції",
      promo_site: "12. Промо-сайт",
      verify_offer: "13. Верифікація",
      web_site: "14. Сайт",
      main_rules: "15. Основні правила",
      pm_points: "16. XP",
      freebet_offer: "17. FreeBet",
      main_terms: "1. Основні положення Пропозиції:",
      main_terms_2: "2. Умови участі в Пропозиції:",
      main_terms_3: "3. Призи та Бонуси.",
      main_terms_4: "4. Умови отримання фізичних призів.",
      main_terms_5: "5.Заключні положення.",
      p1: "X-Pass – твоя унікальна пропозиція від Johnny24 з купівлі призів та подарунків за ігровий прогрес.",
      p2: "Виконуй квести та отримуй XP, які можна обміняти на FreeSpins, FreeBet, SportBonus, лімітований мерч сайту, гаджети та ігрові матеріали.",
      p3: "Основні терміни:",
      p4: "Акція «Xpass24», організована і проведена Організатором.",
      p5: "(далі Сайт) ресурс Johnny24 та відповідальні особи у його складі; ",
      p6: "Особа, яка відповідає пунктам 1.2.-1.4. Правил Акції і взяла участь у Акції.",
      p7: "Ігровий інтернет-рахунок Учасника, зареєстрований на Сайті або в Мобільному додатку.",
      p8: "часовий проміжок встановлений Організатором, який починається 04.09.2024 00:00 і триватиме до офіційного інформування Організатором про завершення Пропозиції; ",
      p9: "Виграш в Акції. Види, кількість, умови та строки отримання Призів визначаються відповідно до пункту 3 Правил.",
      p10: "Завдання, розміщене на Промо-сайті та на платформі Johnny24, успішне виконання якого надає Учаснику право отримати Приз.",
      p11: "Офіційні правила Акції, які розміщуються на Промо-сайті.",
      p12: "Акція проводиться на Сайті.",
      p13: "З «12» травня 2024 року і проводиться безстроково до оголошення Організатором завершення Акції.",
      p14: "Республіка Казахстан.",
      p15: "Процес перевірки та/або підтвердження персональних даних Учасника.",
      p16: "Правила роботи, прийому ставок і проведених парі Організатора, які розміщуються на Сайті.",
      p17: "Одиниця, що отримується у порядку і на умовах Правил.",
      p18: "Нарахована Організатором на Логін неподільна сума грошових коштів, яка не підсумовується з іншими грошовими коштами на Логіні і є одним із видів призів. У разі виграшу ставки, зробленої з використанням FreeBet, Учасник отримує тільки суму виграшу без урахування суми ставки. Сума, умови та строки отримання FreeBet визначаються відповідно до положень Правил.",
      p19: "Основні положення визначають порядок, терміни, умови проведення та участі в Пропозиції, кількість Призів, строки, порядок та місце їх отримання.",
      p20: "Організатор залишає за собою право вносити зміни та оновлювати зміст або формат Правил, а також виключати будь-який із Призів з розіграшу в Акції у будь-який час без попереднього повідомлення. Інформація про внесені зміни розміщується Організатором на Сайті. ",
      p21: "Беручи участь в Акції, Учасник підтверджує ознайомлення та повну згоду з Правилами, та прийняття на себе зобов'язання дотримуватись усіх їхніх умов та вимог.",
      p22: "В Акції забороняється брати участь: працівникам і представникам Організатора, афілійованим з ними особам, близьким родичам таких осіб (згідно з Кодексом Республіки Казахстан «Про шлюб (подружжя) та сім’ю», близькі родичі – батьки (батько, мати), діти, усиновлювачі (усиновителі), усиновлені (усиновлені), рідні та нерідні брати та сестри, дідусі, бабусі, онуки) і представникам третіх осіб, які мають встановлені цивільно-правові та інші відносини з Організатором Акції; особам без громадянства та громадянам інших держав, а також особам, обмеженим в участі в азартних іграх та (або) парі.",
      p23: "Акція не є лотереєю у значенні, передбаченому Законом Республіки Казахстан «Про лотереї та лотерейну діяльність», є стимулюючим розіграшем, спрямованим виключно на залучення нових клієнтів до Організатора; формування та підтримка інтересу до послуг Організатора.",
      p24: "Організатор залишає за собою право вносити зміни та оновлювати зміст або формат Правил, а також виключати будь-який із Призів із розіграшу в Акції в будь-який час без попереднього повідомлення. Інформація про внесені зміни розміщується Організатором на Промо-сайті та/або Сайті. Організатор має право в будь-який час завершити Акцію, у такому випадку інформація про завершення Акції розміщується на Промо-сайті та/або на Сайті не менш ніж за 7 (сім) календарних днів до дати завершення Акції.",
      p25: "Беручи участь у Акції, Учасник підтверджує ознайомлення та повну згоду з Правилами, та прийняття на себе зобов’язання дотримуватись усіх їхніх умов та вимог.",
      p26: "Для участі в Пропозиції, Учасник протягом Терміну проведення Пропозиції на умовах, передбачених Правилами, повинен:",
      p27: "Пройти процедуру авторизації на Сайті, заповнити всі поля зазначені * в особистому кабінеті на Сайті, перейти до профілю в “X-Pass”.",

      p28: "Виконувати Квести, які доступні у період дії акції; ставки мають бути розраховані до завершення Квесту поточного періоду. ",

      p29: "За кожен виконаний Квест Учасник отримує XP. XP відображаються після авторизації Учасника на Промо-сайті та/або Сайті. XP необхідно забрати в період дії Квесту, за який він отримано, натиснувши кнопку «Отримати». Якщо бонус не буде забраний у період, зазначений у цьому пункті, він стає недоступним. ",

      p30: "За кожен виконаний Квест Учасник отримує РМ бали, які він згодом може обміняти на Призи. Отримані Учасником Призи відображаються після авторизації Учасника на Промо-сайті та/або Сайті та/або в Мобільному додатку.",
      p31: "FreeBet, отриманий як Приз, можна використати протягом трьох днів після появи його в особистому кабінеті на Сайті.",
      p32: "Ставки типу «система» та ставки, розраховані за послугою CashOut або створені пізніше, ніж дата і час завершення Квесту поточного дня, не беруть участь в Акції. У «експресах» враховується загальний коефіцієнт.",
      p33: "Ставки FreeBet не враховуються при виконанні Квестів.",
      
      p34: "Призовий фонд Пропозиції формується за кошти Організатора та складається з FreeBet, FreeSpins, Sportbonus, гаджетів, інвентаря та скінів, фірмового мерчу.",
      p35: "В якості Приза Учасником, при накопиченні достатньої кількості XP можуть бути отримані FreeBet, FreeSpins, Sportbonus, гаджети, інвентар та скіни, фірмовий мерч. Склад Призів, що передбачають отримання предметів на акаунті Steam, визначається відповідно до правил платформи Steam на момент активації Приза і може відрізнятися від зображень на Сайті",
      
      p36: "Склад і кількість Призів, що беруть участь в Пропозиції, а також кількість XP, необхідних для отримання Приза, можуть змінюватися Організатором у будь-який час без попереднього повідомлення. Актуальний список Призів та умови їх отримання розміщуються Організатором на Сайті.",
      p37: "У разі вибору в якості Приза будь-якого предмета або комплекту предметів, які мають бути зараховані через акаунт Steam, Учасник повинен активувати отриманий Приз протягом 30 (Тридцяти) хвилин з моменту його отримання. ",
      p38: 'Якщо Учасник акції не може забрати приз, подальша відповідальність за отримання Приза залишається виключно за домовленним сторонами отримувачем.',
      p39: "Протягом 10 днів з моменту оголошення результатів Організатор зв'яжеться з Переможцями, які отримали право на отримання призу, та погодить умови доставки виграного призу.",
      p40: "Якщо Переможець не вийде на зв'язок з Організатором протягом 10 днів після звернення, такий учасник акції втрачає право на отримання призу.",
      p41: "Результати визначення Переможців остаточні та оскарженню не підлягають.",
      p42: "Доставка призів буде здійснена на найближче відділення пошти протягом 30 робочих днів з моменту отримання контактних даних клієнтів, що перемогли в акції. ",
      
      p43: "Організатор не несе відповідальності за використання переможцем призу після його отримання та/або неможливість Переможцем скористатися наданим призом з будь-якої причини. ",
      
      p44: "Організатор не несе відповідальності за неможливість отримання призу Переможцем з будь-яких причин, що не залежать від Компанії, у тому числі: якщо контактна адреса, ім'я та/або прізвище або інші необхідні дані були вказані неправильно, змінені тощо. При цьому такий Переможець не має права на компенсацію від Компанії. ",
      p45: "Своєю участю в Акції, Учасник підтверджує, що ознайомлений з Правилами, їх зміст та умови йому зрозумілі, він з ними повністю згоден і зобов'язується їх дотримуватися.",
      p46: "Організатор має право в будь-який час в односторонньому порядку змінювати умови та правила проведення Акції, інформація про це розміщується Організатором на Сайті. ",
      p47: "Акція доступна лише для одного ігрового рахунку на людину, сім'ю, квартиру, комп'ютер чи IP-адресу.",
      p48: "Організатор залишає за собою право анулювати бонус та відмовити Учаснику у його наданні без пояснення причин у разі, якщо під час перевірки облікового запису Учасника виникнуть підозри у порушенні чесності гри або застосуванні стратегій, які компанія на свій розсуд вважає зловмисними (мультіакаунтинг, гра за некоректними коефіцієнтами, арбітражним ситуаціям тощо.).",
      p49: 'Організатор залишає за собою право виключити будь-якого Учасника з Акції та розіграшу без пояснення причин.',
      p50: 'Ці умови можуть бути змінені та доповнені як у період проведення акції, так і у будь-який час.',
      p51: 'У правилах акційних пропозицій діють загальні правила Johnny24',
    },
  },
  kz: {
    main: {
      begin: "Бастау",
      quests: "Квесттер",
      tournaments: "Турнирлер",
      main: "Басты бет",
      shop: "Дүкен",
      enter: "Кіру",
      to_enter: "Кіру",
      register: "Тіркелу",
      to_register: "Тіркелу",
      take: "Алу",
      begin_quest: "Квестті бастау",
      license:
        '"Қазақстан Республикасының Мәдениет және спорт министрлігінің Туризм индустриясының комитеті" РММ берген 31.12.2020ж. №20019733 букмеркерлік кеңсе қызметін жүзеге асыруға лицензия (17.07.2028ж. дейін жарамды)',
      footer_offer: "Акцияның Ережелері мен Шарттары",
      pm_pass: "Xpass",
      trade_link: "Trade Link",
      back: "Кері қарай",
      link: "Сілтеме",
      skip: "Өткізіп жіберу",
      steam_login: "Steam Login",
      settings: "Баптаулар",
      community: "Қауымдастық",
      public_match_history: "Матчтардың көпшілікке қолжетімді тарихын",
      help: "Қолдау қызметі",
      password: "Құпиясөз",
      phone: "Телефон нөмірі",
      enter_help: "Кіру кезінде көмек",
      clear: "Түсінікті",
      next: "Ары қарай",
      attach: "Қосу",
      product_filter: "Товарлар сүзгісі",
      quest_filter: "Квесттер сүзгісі",
      nothing_here: "Әзірге бұл жерде ешнәрсе жоқ",
      try_another_filters:
        'Сүзгінің басқа баптауларын байқап көріңіз немесе <a class="yellow" href="https://parimatch.kz/" target="_blank">parimatch.kz</a> сайтында PM Hero-ға кіріңіз',
      more: "Тағы да",
      make_bets: "Parimatch-та ұтысты тік",
      go: "Көшу",
      loading: "Парақша жүктелуде...",
      reward_received: "Марапат алынды",
      ended: "Аяқталғандар",
      active: "Белсенді",
      new: "Жаңа",
      end: "Аяқталды",
      soon: "Жақында",
      activated: "Белсенді",
      account: "Шот нөмірі",
      cancel: "Болдырмау",
      quit: "Шығу",
      quit_from_profile: "Профильден шығу",
      confirm_quite: "Шығу туралы шешім ақырғы ма?",
      main_info: "Негізгі Ақпарат",
      profile_settings: "Профиль баптауы",
      attach_trade_link: "Сіздің Steam-дегі айырбастау сілтемеңізді қосыңыз",
      attach_steam: "Өз Steam aккаунтыңызды байлаңыз.",
      reg_first: "Сіз тіркелу немесе кіру арқылы",
      reg_second: "Акцияның Ережелері мен Шарттарымен келісесіз.",
    },
    promo: {
      title1: "Parimatch-пен",
      title1_hg: "ұпайлар жинаңыз",
      title2: "Тапсырмаларды орындаңыз",
      patch1: "Тексеруден өтіңіз",
      patch2: "Шотты толтырыңыз",
      patch3: "Экспресс жинаңыз",
      quests: "Тапсырмалар",
    },
    promogroup: {
      title: "Ұпайларды жүлделерге",
      title_hg: "айырбастаңыз",
      pic1_name: "5000 теңгеге Freebet",
      pic2_name: "CS 2",
      pic3_name: "Dota 2",
      pic4_name: "Лутбокс",
      pic_prize: "846 000 PM ұпайлары",
      desc_title: "ішінде көбірек",
      desc_title_hg: "сыйлықтар",
      shop: "Дүкен",
    },
    prefooter: {
      title: "Бастама",
      title_hg: "бусты",
      desc1: "бастау кезінде",
      desc1_hg: "300 PM ұпай",
      desc1_end: "алыңыз!",
      desc2: "Бастама",
      desc2_hg: "бусттарды",
      na: "лутбоксқа",
      desc1_end_hg: "айырбастаңыз",
    },
    banner: {
      title: "Parimatch-пен фармдаңыз",
      subtitle:
        "Квесттерді орындаңыз, PM балдарын алыңыз және керемет жүлделерге айырбастаңыз",
      btn: "Жүлделерді фармдаңыз",
      title1: "Тапсырмаларды",
      title1_hg: "орындаңыз",
      title2: "Ұпай",
      title2_hg: "жинаңыз",
      title3_hg: "Freebet және скиндерге",
      title3: "",
      title3_suffix: "айырбастаңыз",
      button: "Бастау",
    },
    rules: {
      title: "Бұл қалай жұмыс істейді",
      connect: "Аккаунттарды қосыңыз",
      register:
        "Тіркеліңіз немесе Parimatch аккаунтына кіріңіз және Steam аккаунтын қосыңыз",
      quests: "Квесттерді орындаңыз",
      finish:
        "Жүлделері бар сандықтарды алу үшін Parimatch сайтында PM Hero-да квесттерді орындаңыз. Тапсырмаларды орындау үшін сіз оған қоса PM Pass сайтында PM балдарын аласыз.",
      chest: "Сандықтарды ашыңыз",
      bonuses:
        "Сандықтарда сізді Parimatch-тан бонустар және басқа жүлделер күтіп тұр. Квест неғұрлым қиынрақ болса, соғұрлым лут та құндырақ болады!",
      store: "Жүлделер дүкені",
      change:
        "PM балдарды жинаңыз және PM Pass сайтында бонустарға және басқа керемет жүлделерге айырбастаңыз",
    },
    prizes: {
      title: "Кез келген талғамға арналған жүлделер",
      text1:
        "PM Hero мен PM Pass - бұл шексіз жүлделердің көзі. Parimatch сайтында әр орындалған квест үшін марапттарды және  PM балдарын алыңыз",
      text2:
        "PM Pass дүкенінде ұнағанның барлығын: CS2, Dota 2 үшін скиндер, фрибеттер, мерч және тағы басқаларды PM балдарға сатып алыңыз. Таңдау өзіңізде!",
    },
    quests: {
      text1:
        "Спортқа ұтыстарды тігу немесе Steam арқылы Dota 2 ойнау арқылы квесттерді орындаңыз. Тапсырмалардың толық тізімін көру үшін Parimatch сайтына кіріңіз және PM Hero бөлімін табыңыз.",
      text2:
        "Квесттер күн сайын жаңартылып тұрады - жүлделерді шексіз фармдаңыз!",
    },
    faq: {
      question1: "Parimatch және Steam аккаунттарын қалай байлауға болады?",
      answer1_text1:
        "Dota 2-де бейресмилік баптауын сіздің ойындар тарихы ашық болатындай түрде қойғаныңызға көзіңізді жеткізіңіз.",
      answer1_text2:
        'Сонымен қатар сіз <a class="yellow" href="https://parimatch.kz/" target="_blank">parimatch.kz</a> сайтында немесе қосымшасында тіркелген клиент болуыңыз қажет. ',
      answer1_text3:
        'Егер сіз тіркелмеген болсаңыз, <a class="yellow" href="https://parimatch.kz/ru/regtel/3" target="_blank">https://parimatch.kz/ru/regtel/3</a> сілтемесі бойынша өтіңіз және Parimatch-та тіркеулік жазбасын жасаңыз.',
      answer1_text4:
        'Содан кейін сізге осы парақшада "Қатысу" батырмасын басу керек. Үлгіге сіз тіркелгенде пайдаланған өз ID Parimatch-ты және құпия сөзді енгізіңіз.',
      answer1_text5:
        'Өз ID-ді "Менің аккаунтым" бөлімінен көшіре аласыз - <a class="yellow" href="https://parimatch.kz/ru/my-account" target="_blank">https://parimatch.kz/ru/my-account</a>',
      question2: "Не үшін Steam аккаунтын байлау керек?",
      answer2:
        "Квесттер тек Parimatch сайтында ғана емес, сонымен қатар Dota 2-де де орындауға болады. Егер сіз Steam, аккаунтын байласаңыз, сіз өз сүйікті ойыныңыздан ләззат атумен қатар, ол үшін жүлделерді де ала аласыз!",
      question3: "Менде Steam аккаунты жоқ болса, мен қатыса алам ба?",
      answer3_text1:
        "Ия, сіз Dota 2-ге қатысы жоқ квесттерді орындау арқылы қатыса аласыз. Ол үшін сізге тек Parimatch аккаунты ғана қажет.",
      answer3_text2:
        "PM Hero геймификациясы бөліміне өтіңіз және ойнауды дәл қазір бастаңыз.",
      question4: "Қалай қатысуға болады?",
      answer4_text1: "Қатысу үшін:",
      answer4_text2: "Авторизациядан өтіңіз және парақшаға көшіңіз; ",
      answer4_text3:
        'Қатысуды растау үшін "Шақыруды қабылдау" батырманы басыңыз;',
      answer4_text4:
        "Күнде квесттерді орындаңыз және жүлделері мен кристалдары бар кепілдендірілген андықтарды алыңыз;",
      answer4_text5:
        "Сандықтардағы кристалдарды жинаңыз және ойыншылар рейтингісінде көтеріліңіз; ",
      question5: "Кім қатыса алады?",
      answer5:
        "Акция басталу сәтінде 21 жасқа толған, Қазақстан Республикасының азаматтары болып табылатын, Қазақстан Республикасының аумағында тұратын және Қазақстан Республикасы азаматының жарамды жеке куәлігі бар тұлғалар қатыса алады.",
      question6:
        "Заттарды алу үшін Стимде құрал-жабдықтарды қалай ашуға болады?",
      answer6_text1:
        "Дүкеннен заттарды алу үшін сіздің құрал-жабдықтарыңыз көрінетіндей ашық болуы тиіс.",
      answer6_text2: "Ол үшін сізге келесі әрекеттерді жасау керек:",
      answer6_text3: "Стим-клиентті ашыңыз;",
      answer6_text4:
        "Меңзерді жоғарғы оң жақтағы өз логиніңізге апарыңыз. Ашылма мәзірде «Құрал-жабдықтарды» басыңыз;",
      answer6_text5:
        "«Тағы» қосымша бетін басыңыз және «Бейресмилік баптауын» таңдаңыз;",
      answer6_text6:
        "«Профиль мәртебесі» және «Құрал-жабдықтар» тарауларында «Ашық» сөзіне қарсы қанат белгісін қойыңыз;",
      answer6_text7: "«Өзгертулерді сақтауды» басыңыз.",
      answer7:
        "Мәселе туындаса, 24/7 бойы жұмыс істейтін қолдау қызметіне хабарласыңыз",
    },
    profile: {
      title: "Профиль",
      info: "Аккаунт туралы ақпарат",
      received_points: "Алынған ұпайлар",
      current_balance: "Ағымдағы теңгерім",
      dota_history_closed: "Матчтар тарихы жабық, баптауларды тексеріңіз",
      go_to_settings: "Dota 2-ға кіріңіз және Баптаулар бөліміне өтіңіз.",
      in_chapter:
        "Сіз Қауымдастық бөлімінде Матчтардың көпшілікке қолжетімді тарихын көре аласыз, оны басыңыз және тарих ашық болады.",
      match_history: "Матчтар тарихы",
      match_history_closed: "Матчтар тарихы жабық, баптауларды тексеріңіз",
      go_to_dota2: "Dota 2-ге кіріңіз және Баптаулар бөліміне өтіңіз.",
      go_to_community:
        "Сіз Қауымдастық бөлімінде Матчтардың көпшілікке қолжетімді тарихын көре аласыз, оны басыңыз және тарих ашық болады.",
      history_open: "Сіздің матчтар тарихыңыз ашық",
      steam_attached: "Сіздің Steam-дегі айырбастау сілтемеңіз қосылды",
      steam_is_not_attached: "Сіздің Steam aккаунт байланбаған",
    },
    welcome: {
      intro_title: "- сіздің үздік жүлделер әлеміне жолдама",
      intro_text1: "Бұл Париматч компаниясының ресми өнімі.", // перевести
      intro_text2:
        '<a class="yellow" href="https://parimatch.kz/" target="_blank">parimatch.kz</a> сайтында және сіздің Dota 2 сияқты сүйікті ойындарыңызда тапсырмаларды орындаңыз, бонустық баллдарды жинаңыз және оларды дүкендегі скиндерге және басқа заттарға айырбастаңыз.',
      shop_and_quests_shop: "Квесттер мен",
      shop_and_quests_quests: "Дүкен",
      shop_and_quests_text1:
        "Бәрі өте оңай. Квесттер парақшасында сізге қолжетімді тапсырмаларды бақылап отырыңыз.",
      shop_and_quests_text2:
        "Әр тапсырмада сіз қанша PM балл ала алатыныңыз көрсетілген. Орындағаннан кейін сіздің баллдарыңыз pm-pass профиліңізге есептеледі.",
      shop_and_quests_text3:
        "Сіз оларды Дүкен парақшасында айырбастай аласыз. ",
      quest_guide: "Құттықтаймыз, керемет сыйлықтар",
      quest_guide_hg: "алуыңызға бір қадам қалды",
      obj_one_title: "Parimatch-пен ұпай жинаңыз",
      obj_one_desc:
        "PM ұпайларын квесттерді орындау және стикербуктарды жинау арқылы алуға болады.",
      obj_two_title: "Сіздің бірінші квестіңіз",
      obj_two_desc:
        "Тексеруден өтіп 2000 теңгеге фрибет пен 300 PM PASS ұпайларын алыңыз ",
      trade_link_text1:
        "PM Pass дүкенінде скиндерді және ойын заттарын алу үшін Steam-нен өз айырбастауға сілтемеңізді қосыңыз",
      trade_link_text2: "Сілтемені қалай алуға болады?",
      steam_text:
        "Dota 2-де квесттерді орындау үшін сізге Steam-дегі тіркеулік жазбаңызды қосу керек",
      skip_step:
        "Сіз осы қадамды өткізіп жіберіп, сілтемені кейінірек қоса аласыз",
    },
    reg: {
      more_than_21: "Мен 21 жастан асқанмын",
      accept_offer: "Мен оферта шартымен келісемін",
      activate_bonus: "Бірінші депозитке бонусты іске қосыңыз",
      bonus_offer: "Бонустық ұсыныс шарттары",
      have_account: "Аккаунтыңыз бар ма?",
      no_account: "Аккаунтыңыз жоқ па?",
    },
    help: {
      have_trouble: "Сізде кіру кезінде қиындықтар туындаған сияқты.",
      ask_help: "Қолдау қызметіне хабарласып көріңіз.",
      find_trade_link:
        "Steam-де өз трейд URL-ды табу үшін келесі әрекеттерді жасаңыз:",
      find_nickname:
        "Профиль мәзірі шығу үшін өз никнейміңізге меңзерді апарыңыз;",
      go_to: "Құрал-жабдықтарға өтіңіз",
      click_button: 'Келесі батырманы басыңыз: "Айырбастау ұсыныстары";',
      open: 'Келесіні ашыңыз: "Кім маған айырбастау ұсыныстарын жібере алады?";',
      trade_text1:
        '"Бөгде сайттар" бағанында "Айырбастауға сілтеме" жолағы бар. ',
      down_here: "Осы жерде төменде Steam трейд сілтемесі орналасқан.",
    },
    errors: {
      min_6_symbols: "Кемінде 6 таңба",
      min_1_number: "Кемінде 1 сан (0-9)",
      number_registered: "Телефон нөмірі әлдеқашан тіркеліп қойған",
      not_supported: "Телефон нөмірі бойынша қолдау көрсетілмейді",
      error_data: "Деректерді өңдеу кезінде қате орын алды",
      no_account:
        "Деректер дұрыс енгізілмеген сияқты немесе сізде әлі аккаунт жоқ",
    },
    notifications: {
      steam_attached: "Steam аккаунт қосылды",
      dota_history_opened: "Матчтар тарихы ашық",
      trade_link_attached: "Айырбастауға сілтеме қосылды",
      trade_link_edited: "Айырбастауға сілтеме өзгертілді",
      steam_edited: "Steam аккаунт өзгертілді",
      present_send: "Сыйлық сізді Steam-де күтуде. Алуға асығыңыз!",
      not_enough_cash: "Сізде айырбастау үшін баллдар жеткіліксіз",
      add_trade_link: "Профильге Steam-де айырбастауға сілтемені қосыңыз",
      technical_issues:
        "Техникалық жұмыстар жүргізіліп жатыр. Айырбастау қолжетімсіз.",
      account_copied: "Account ID көшірілді",
      steam_copied: "Steam ID көшірілді",
      wrong_trade_link: "Айырбастауға сілтеменің пішімі қате",
    },
    offer: {
      akciya: "1. Акция",
      organizator: "2. Ұйымдастырушы",
      member: "3. Қатысушы ",
      login_offer: "4. Логин",
      mobile_app: "5. Мобилді қосымша",
      prize_offer: "6. Жүлде",
      offer_header: "«PM Pass» акциясының ережелері",
      quest_offer: "7. Квест",
      rules_offer: "8. Ережелер",
      deadline_offer: "10. Акцияны өткізу мерзімі ",
      location_offer: "9. Акцияның өтетін орны ",
      territoy_offer: "11. Акцияны өткізу аумағы ",
      promo_site: "12. Промо-сайт",
      verify_offer: "13. Верификация",
      web_site: "14. Сайт",
      main_rules: "15. Негізгі ережелер",
      pm_points: "16. РМ балл",
      freebet_offer: "17. FreeBet",
      main_terms: "1. Жалпы ережелер.",
      main_terms_2: "2. Акцияға қатысудың шарттары.",
      main_terms_3: "3. Жүлделер.",
      main_terms_4: "4. Қорытынды ережелер.",
      p1: "PM Pass - бұл саған өз жүлдеңді өзің таңдауға мүмкіндік беретін бірегей мерзімсіз акция.",
      p2: "PM Hero-да квесттерді орындаңыз, РМ балдарды алыңыз және оларды Промо-сайтта лутбокстарға, кейстерге, FreeBet және басқа кепілдендірілген жүлделерге айырбастаңыз. ",
      p3: "Негізгі терминдер мен анықтамалар:",
      p4: "Ұйымдастырушы ұйымдастыратын және өткізетін «PM Pass» акциясы.",
      p5: "«РМ Бет» букмекерлік кеңсесі» жауапкершілігі шектеулі серіктестігі, БСН 161240020520, Қазақстан Республикасының заңнамасына сәйкес тіркелген және мына мекенжай бойынша орналасқан заңды тұлға: Қазақстан Республикасы, Алматы облысы, Қонаев қаласы, Алматинская көшесі, 6/2 ғимараты, 2 т.е.ж., пошталық индексі 040800. ",
      p6: "Акция Ережелерінің 1.2-1.4. тармақтарына сай келетін  және Акцияға қатысқан тұлға.",
      p7: "Қатысушының Сайттағы немесе Мобилді қосымшада тіркеген интернет-ойын шоты.",
      p8: "Ұйымдастырушының iOS және Android мобилді операциялық жүйелеріне арналған parimatch.kz ресми мобильді қосымшасы.",
      p9: "Акциядағы ұтыс.  Жүлделердің түрлері, саны, шарттары мен мерзімдері Ережелердің 3-тармағына сәйкес айқындалады.",
      p10: "Промо-сайтта және PM Hero платформасында көрсетілген тапсырма, оны сәтті орындағанда Қатысушыға Жүлдені алу құқығы беріледі.",
      p11: "Промо-сайтта көрсетілген Акцияның ресми ережелері.",
      p12: "Акция Сайтта және Мобильді қосымшада өткізіледі.",
      p13: "2024 жылғы «12» мамырдан бастап және Ұйымдастырушы Акцияның аяқталғанын жариялағанға дейін мерзімсіз өткізіледі.",
      p14: "Қазақстан Республикасы.",
      p15: "Қатысушының дербес деректерін тексеру және/немесе растау үдерісі.",
      p16: "Сайтта орналастырылатын Ұйымдастырушының жұмыс істеу, тігілген бәстерді қабылдау және өткізілетін паридің ережелері.",
      p17: "Ереже тәртібінде және талаптарында алынатын бірлік.",
      p18: "Ұйымдастырушы Логинге есептейтін, Логиндегі қалған ақшалай қаражатпен қосылмайтын және жүлделердің бір түрі болып табылатын ақшалай қаражаттың бөлінбейтін сомасы. FreeBet көмегімен тігілген бәсті ұтып алған жағдайда, Қатысушы тігілген бәстің сомасын есепке алмай, тек ұтыс сомасын алады.  FreeBet сомасы, шарттары және алу мерзімі Ережелердің қағидаларына сәйкес анықталады.",
      p19: "Ережелер Акцияны өткізудің және оған қатысудың тәртібін, шарттарын, мерзімдерін, Жүлделердің санын, оларды алудың  мерзімдерін, тәртібін және орнын анықтайды.",
      p20: "Акцияға Акцияны өткізу сәтінде 21 (жиырма бір) жасқа толған, Қазақстан Республикасының азаматтары болып табылатын, Қазақстан Республикасының аумағында тұрақты тұратын, Қазақстан Республикасы азаматының жарамды жеке куәлігі бар, Сайтта немесе Мобилді қосымшада бұрын тіркелген/қазір тіркелген және Логинде жеке деректерін дұрыс толтырған тек әрекет істеуге қабілетті жеке тұлғаларға ғана қатысу құқығы беріледі.",
      p21: "Егер Қатысушы Ережелердің 1.2. тармағының талаптарына сәйкес келмесе, онда ол Қатысушылар қатарынан шығарылады.",
      p22: "Акцияға Ұйымдастырушының жұмыскерлеріне және өкілдеріне, аталған тұлғалардың және өкілдердің жақын туыстарына, бұл тұлғалардың үлестес тұлғаларына (Қазақстан Республикасының «Неке (жұбайылық) және отбасы туралы» кодексіне сәйкес, жақын туыстары – ата-аналары (ата-анасы), балалары, асыраушылары, асырап алынған ұл-қыздары, ата-анасы бір және ата-анасы бөлек ағалы-інілер мен апалы-сіңлілер (аға-қарындастар), аталары, әжелері, немерелері)  және Акцияны Ұйымдастырушымен азаматтық-құқықтық және өзге де қатынастары бар үшінші тұлғалардың өкілдеріне; сондай-ақ азаматтығы жоқ адамдарға және басқа мемлекеттердің азаматтарына, құмар ойындарына және (немесе) бәске қатысуға шектеу қойылған тұлғаларға қатысуға тыйым салынады.",
      p23: "Акция «Лотереялар және лотерея қызметі туралы» Қазақстан Республикасының Заңында көзделген мағына бойынша лотерея болып табылмайды, ал тек қана Ұйымдастырушыға жаңа клиенттерді тартуға, Ұйымдастырушының қызметтеріне қызығушылықты қалыптастыруға және сақтауға бағытталған ынталандырушы ұтыс ойыны болып табылады.",
      p24: "Ұйымдастырушы Ережелердің мазмұнына немесе форматына өзгерістерді енгізу және жаңарту, сондай-ақ Жүлделердің кез келгенін алдын ала ескертусіз кез келген уақытта Акцияның ұтыс ойынында ойнатудан алып тастау құқығын өзіне қалдырады. Енгізілген өзгерістер туралы ақпарат Ұйымдастырушымен Промо-сайтта және/немесе Сайтта орналастырылады. Ұйымдастырушы Акцияны кез келген уақытта аяқтауға құқылы, бұл жағдайда Акцияның аяқталуы туралы ақпарат Акцияның аяқталу күніне дейін кемінде 7 (жеті) күнтізбелік күн бұрын Промо-сайтта және/немесе Сайтта орналастырылады.",
      p25: "Акцияға қатысу арқылы Қатысушы Ережелермен танысқанын және толық келіскенін және олардың барлық шарттары мен талаптарын сақтауға қатысты өзіне міндеттеме алғанын растайды.",
      p26: "Акцияға қатысу үшін Қатысушы Акцияны Өткізу мерзімі ішінде Ережелермен көзделген шарттармен келесі әрекеттерді жасауға міндеттенеді:",
      p27: "Сайттағы немесе Мобильді қосымшадағы жеке кабинетте * белгісімен белгіленген (міндетті түрде толтырылуы керек) барлық жолақтар толтырып, Сайтта немесе Мобильді қосымшада авторландыру рәсімінен өту, Промо-сайтқа көшу және жоқ болса, PM Hero профилін жасау;",
      p28: "Steam-де (store.steampowered.com) тіркеу рәсімінен өту, Промо-сайт арқылы трейд сілтемені Steam-дегі өз аккаунтыңызға байлау және құрал-жабдықтарды барлығына ашық қылу керек;",
      p29: "Акцияның әрекет ету кезеңінде қолжетімді Квесттерді орындау; тігілген ұтыстар ағымдағы кезеңдегі Квест аяқталғанға дейін есептелуі керек.",
      p30: "Әр орындалған Квест үшін Қатысушы РМ балдарды алады, ол оларды болашақта Жүлделерге айырбастай алады. Қатысушымен алынған Жүлделер Қатысушы Промо-Сайтта және/немесе Сайтта және/немесе Мобильді қосымшада авторландырудан өткеннен кейін көрсетіледі.",
      p31: "Жүлде ретінде алынған FreeBet-ті ол жеке Сайттағы кабинетте шыққаннан кейін үш күн ішінде пайдалануға болады.",
      p32: "Жүйе» түріндегі тігілген бәстер және CashOut қызметі бойынша немесе ағымдағы күн Квестінің аяқталу күні мен уақытынан кеш жасалып тігілген ұтыстар Акцияға қатыспайды. «Экспресстерде» жалпы коэффициент ескеріледі.",
      p33: "Квесттерді орындау кезінде FreeBet тігілген ұтыстар есепке алынбайды.",
      p34: "Акцияның жүлде қоры Ұйымдастырушының ақшалай қаражаты есебінен қалыптастырылады.",
      p35: "РМ балдардың жеткілікті саны жиналған кезде Қатысушы Жүлделер ретінде лутбокстарды, кейстерді, FreeBet және басқа кепілдендірілген жүлделерді ала алады.  Steam аккаунтында заттарды алуды тұспалдайтын лутбокстардың, кейстердің, FreeBet және басқа Жүлделердің құрамы Жүлдені іске қосу сәтіндегі Steam алаңының ережелеріне сай анықталады және Промо-сайттағы суреттен өзгеше болуы мүмкін.",
      p36: "Акцияға қатысатын Жүлделердің құрамы және саны, сондай-ақ Жүлдені алу үшін қажетті РМ балдардың саны Ұйымдастырушымен алдан ала хабарлаусыз кез келген уақытта өзгертілуі мүмкін.  Жүлделердің өзекті тізімі және оларды алу шарттары Ұйымдастырушымен Промо-сайтта орналастырылады.",
      p37: "Жүлде ретінде Steam аккаунты арқылы алынуы тиіс кез келген зат немесе заттар жиынтығы таңдалған жағдайда, Қатысушы алынған Жүлдені ол алынған сәттен бастап 30 (отыз) минут ішінде іске қосуға міндетті.",
      p38: "Қатысушы Акцияға қатысу арқылы Ережелермен танысқандығын, олардың мазмұны және шарттары оған түсінікті екендігін, олармен толық келісетіндігін және оларды сақтауға міндетті екендігін растайды.  Сонымен қатар Қатысушы оның дербес деректерін (тегі, аты, әкесінің аты, мекенжайы, тұлғаны куәландыратын құжат туралы ақпарат, ЖСН, туған жері мен күні, сурет, байланыс телефонының нөмірі және т.б.) жинауға, өңдеуге және пайдалануға, ол ұсынған өзі туралы ақпараттың Ұйымдастырушымен маркетингтік және/немесе кез келген басқа мақсаттардағы әдістермен (оның ішінде үшінші тұлғаларға беру арқылы) өтеусіз пайдалануға, атап айтқанда қатысушының атын, тегін, суретін, сұхбатты немесе ол туралы басқа материалдарды жарнамалық/маркетингтік мақсаттарда пайдалануға, оның ішінде бұқаралық ақпарат құралдарында, кез келген баспа, аудио- және бейнематериалдарда жариялау, БАҚ-қа сұхбат беру, сондай-ақ ақпаратты, хабарламаларды (оның ішінде жарнамалық сипаттағы) және т.б. тапсыру құқығын аумақ, уақыт және пайдалану әдісі бойынша ешбір шектеусіз беруге өз келісімін береді. Осындай пайдалану Ұйымдастырушымен және/немесе басқа үшінші тұлғамен ешқандай түрде өтелмейді.",
      p39: "Акцияға Қатысушы Акцияға қатысу үшін хабарлаған тіркеу деректеріндегі өзінің тегін, атын, әкесінің атын, туған жылы мен мекенжайын хабарламада көрсетумен, Акция Қатысушысы дербес деректерін жинау, өңдеу және сақтауға берген рұқсатын Қазақстан Республикасы, Қонаев қаласы, Алматинская көшесі, 6/2 ғимараты, 2 т.е.ж., пошталық индексі 040800 мекенжайына жазбаша түрде хабарлама жіберіп, кері қайтарып алуға құқылы.",
      p40: "Келісімді қайтарып алу туралы хабарлама алынған жағдайда, Ұйымдастырушы және ол уәкімдік берген тұлғалар осындай Қатысушының дербес деректерін өңдеуді тоқтатады және оның дербес деректерін Қазақстан Республикасының қолданыстағы заңнамасымен белгіленген тәртіпте және мерзімде жояды.",
      p41: "Қатысушы өзінің  дербес деректерін кері қайтарғаннан кейін, яғни қайтару  нәтижесінде оның дербес деректері жойылғаннан соң, Акцияның өткізілуімен байланысты іс-әрекеттердің орындалмауына Ұйымдастырушы жауапты емес.",
      p42: "Ұйымдастырушы Акцияны өткізу талаптары мен ережелерін кез келген уақытта, біржақты тәртіппен өзгертуге құқылы.  Ол жайлы ақпарат Ұйымдастырушымен Промо-сайтта және/немесе Сайтта орналастырылады.",
      p43: "Акция тек бір адамға, бір отбасына, бір пәтерге, бір компьютерге немесе бір IP мекенжайына қарасты ойын шотына қолжетімді.",
      p44: "Ұйымдастырушы Қатысушының Логинін тексеру барысында оның тыйым салынған стратегияларды пайдаланғандығын (мультиаккаунтинг, бұрыс коэффициенттермен ойнау, арбитражды жағдайлар  және т.б.) анықтаса және Ұйымдастырушы оларды қастық әрекет деп тапса, Ұйымдастырушы  кез келген Жүлдені жою және себебін алдын ала ескертпей-ақ Қатысушыға бонус беруден бас тарту құқығын өзіне қалдырады.",
      p45: "Ұйымдастырушы кез келген Қатысушыны Акциядан және ұтыс ойынынан себебін түсіндірместен шығару құқығын өзіне қалдырады.",
      p46: "Даулы мәселелер бойынша наразылықтар осындай мәселе туындаған сәттен бастап 60 (алпыс) күн ішінде қабылданады.  Бұл ретте нәтижесі ретінде осы мәселенің пайда болуы болып табылатын оқиғаның күні даулы мәселенің туындаған күні болып есептеледі. Осы мерзім өткеннен кейін ешқандай талаптар қабылданбайды.",
    },
  },
};

const currentLanguage = localStorage.getItem("language") || "ru";

i18n.use(initReactI18next).init({
  resources,
  lng: currentLanguage,
  fallbackLng: "ru",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
